import { render, staticRenderFns } from "./FaceAuthModule.vue?vue&type=template&id=194da9b1&scoped=true&"
import script from "./FaceAuthModule.vue?vue&type=script&lang=js&"
export * from "./FaceAuthModule.vue?vue&type=script&lang=js&"
import style0 from "./FaceAuthModule.vue?vue&type=style&index=0&id=194da9b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194da9b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
